import React from 'react';
import { Button } from 'antd';

const SaveButton = ({ label='Next', htmlType, ...rest }) => {
	return (
		<Button
			{...rest}
			type="primary"
			htmlType={htmlType}
		>
			{label}
		</Button>
	);
};

export default SaveButton;